import React from 'react';
import { motion } from 'framer-motion';
import { ReadMore } from './ReadMore';

const STATS = [
  ['0', 'dropped frames', 'across all six cameras'],
  ['0.97', 'visual–inertial agreement', 'camera motion vs. IMU (≥ 0.90 is good)'],
  ['99.0%', 'frames tracked', 'ORB-SLAM3, zero tracking resets'],
  ['0.98', 'rotation consistency', 'video vs. gyroscope'],
  ['99.96%', 'valid depth pixels', 'Video Depth Anything'],
  ['98.1%', 'depth consistency', 'stable frame to frame, no flicker'],
];

const MODELS = ['WiLoR', 'ORB-SLAM3', 'Depth Anything V2', 'Video Depth Anything'];

export const BenchmarksSummary = () => (
  <section className="py-24 lg:py-32 border-t border-white/10" data-testid="benchmarks-summary-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#FF7A00]/70 mb-4 block">Benchmarks</span>
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight max-w-3xl mb-4">Proven on the models Physical AI teams already use</h2>
      <p className="text-base text-white/45 max-w-2xl mb-6">
        We ran standard open-source models for hand pose, head tracking and depth on our recordings. Every result landed inside the published good range.
      </p>
      <div className="flex flex-wrap gap-2 mb-12" data-testid="benchmarks-models">
        {MODELS.map((m) => <span key={m} className="rounded-full border border-[#FF7A00]/40 bg-[#FF7A00]/10 px-3 py-1 text-xs font-semibold text-[#FF7A00]">{m}</span>)}
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden" data-testid="benchmarks-stats">
        {STATS.map(([v, l, s], i) => (
          <motion.div key={l} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.45, delay: i * 0.06 }}
            className="p-6 lg:p-8 bg-[#111111]">
            <div className="font-mono text-3xl lg:text-4xl font-bold gradient-text w-fit">{v}</div>
            <div className="text-sm font-semibold text-white/85 mt-2">{l}</div>
            <div className="text-xs text-white/40 mt-1">{s}</div>
          </motion.div>
        ))}
      </div>
      <ReadMore to="/technology/benchmarks" testid="benchmarks-read-more" className="mt-10">Read more about the benchmarks</ReadMore>
    </div>
  </section>
);
